import styled from 'styled-components'
import { Box } from 'rebass'

export const Container = styled(Box)`
  min-height: 100vh;
`

export default {}
